/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { SettingsGetConnectionQueryResponse, SettingsGetConnectionPathParams } from "../models/SettingsGetConnection";

export function getSettingsGetConnectionUrl(station: SettingsGetConnectionPathParams["station"], platform: SettingsGetConnectionPathParams["platform"]) {
  const res = { method: 'GET', url: `/connections/${station}/${platform}/settings` as const }
  return res
}

/**
 * @description Returns the connection settings for a specific platform and station. If no connection exists, returns default settings.
 * @summary Get connection settings for a station
 * {@link /connections/:station/:platform/settings}
 */
export async function settingsGetConnection(station: SettingsGetConnectionPathParams["station"], platform: SettingsGetConnectionPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SettingsGetConnectionQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getSettingsGetConnectionUrl(station, platform).url.toString(), ... requestConfig })
  return res.data
}